import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appInViewport]',
  standalone: true
})
export class InviewportDirective implements OnInit, OnDestroy {
  @Input('appInViewport') msgId!: string;   // 👈 alias Input to selector
  @Output() seen = new EventEmitter<string>();

  private observer?: IntersectionObserver;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // console.log('InViewport:', entry.isIntersecting, this.msgId);
        if (entry.isIntersecting) {
          this.seen.emit(this.msgId);
          this.observer?.unobserve(this.el.nativeElement); // only trigger once
        }
      });
    }, { threshold: 0.5 }); // at least 50% visible

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
